<template>
  <div
    class="c-banner-bonus"
    v-if="
      bonusReceived.expirable_bonus_next_expiration &&
      bonusReceived.expirable_bonus_amount
    "
  >
    <router-link :to="{ path: '/carteira?go=shopping' }">
      <div class="columns is-multiline c-banner-bonus--columns">
        <div class="column c-banner-bonus__text">
          <p class="c-banner-bonus__title">
            Bônus {{ bonusReceived.expirable_bonus_amount | currencyInteger }}
            <span class="icon">
              <base-icon
                width="15px"
                height="17px"
                name="painel/chevron-left-icon"
              />
            </span>
          </p>
          <p class="c-banner-bonus__description">
            Um presente do Casar.com para você usar em sua primeira compra no
            Shopping
          </p>
          <p class="c-banner-bonus__valid">
            Válido até
            {{
              bonusReceived.expirable_bonus_next_expiration | dateWithoutHours
            }}
          </p>
        </div>
        <div class="column is-4-desktop c-banner-bonus__gift">
          <img
            class="c-banner-bonus__gift--img"
            :src="img.imgGift"
            :alt="img.name"
          />
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import giftImg from '@/assets/img/gift.png'

export default {
  computed: {
    bonusReceived() {
      return this.$store.state.wallet.bonusReceived.bonus_amount > 0
        ? this.$store.state.wallet.bonusReceived
        : false
    },
  },

  data() {
    return {
      img: {
        imgGift: giftImg,
        name: 'Bônus para o shopping Casar.com',
      },
    }
  },
}
</script>

<style lang="scss">
.c-banner-bonus {
  background-image: linear-gradient(#fdd6e3, #ffc3d7);
  margin: 2em 1em 15px;
  border-radius: 8px;

  @media (min-width: $tablet) {
    margin: 2em 2em 15px;
    overflow: unset;
  }

  &--columns {
    min-height: 145px;
    display: flex;
    border-radius: 8px;
    margin: 0 auto;
    overflow: hidden;

    @media (min-width: $tablet) {
      min-height: 160px;
    }
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 0 10px 25px;

    @media (min-width: $tablet) {
      min-height: 153px;
      overflow: unset;
      padding: 10px 20px 10px 40px;
    }
  }

  &__title {
    font-size: 19px;
    font-weight: bolder;
    color: $gray-7;

    @media (min-width: $tablet) {
      font-size: 24px;
    }
  }

  &__description {
    line-height: 1;
    margin-bottom: 8px;
    margin-top: 6px;
    color: $gray-7;
    font-size: 14px;

    @media (min-width: $tablet) {
      font-size: 16px;
    }
  }

  &__valid {
    font-size: 12px;
    color: $gray-6;
    font-weight: bold;
  }

  &__gift {
    padding: 0 !important;

    &--img {
      height: 100%;
      width: 100%;
      object-fit: cover;

      @media (min-width: $tablet) {
        font-size: 16px;
        object-fit: unset;
      }
    }
  }
}
</style>
